import Exports from '../../../store/exports';

angular
    .module('festzelt-os.modules.exports')
    .factory('Exports', [
        '$injector',
        ($injector) => new Exports({}, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/exports/store/exports.js